import { render, staticRenderFns } from "./AskForm.vue?vue&type=template&id=7a03e0ac&scoped=true&"
import script from "./AskForm.vue?vue&type=script&lang=js&"
export * from "./AskForm.vue?vue&type=script&lang=js&"
import style0 from "./AskForm.vue?vue&type=style&index=0&id=7a03e0ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a03e0ac",
  null
  
)

export default component.exports